// extracted by mini-css-extract-plugin
export default {"container":"O4oWOIel","icon":"DuwOJH0r","menuItems":"fQcqpzLm"};